/**
 * Reward 与账号绑定：游客 uid / 登录 uid 变化时清理任务内存缓存。
 */
import {
  clearRewardTasksCache
} from './rewardService'

const STORAGE_BOUND_SUB_KEY = 'appleshort_reward_bound_sub'

export function syncRewardStorageForAccount (sub) {
  const nextSub = sub || ''
  const prevSub = localStorage.getItem(STORAGE_BOUND_SUB_KEY) || ''

  if (prevSub && nextSub && prevSub !== nextSub) {
    clearRewardTasksCache()
  }

  if (nextSub) {
    localStorage.setItem(STORAGE_BOUND_SUB_KEY, nextSub)
  }
}

export function clearRewardBoundSub () {
  localStorage.removeItem(STORAGE_BOUND_SUB_KEY)
}
